import { render, staticRenderFns } from "./cookie-bar.vue?vue&type=template&id=37991349"
import script from "./cookie-bar.vue?vue&type=script&lang=js"
export * from "./cookie-bar.vue?vue&type=script&lang=js"
import style0 from "./cookie-bar.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports